var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButtonArrowPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9697 6.96967C14.2626 6.67678 14.7374 6.67678 15.0303 6.96967L20.0303 11.9697C20.3232 12.2626 20.3232 12.7374 20.0303 13.0303L15.0303 18.0303C14.7374 18.3232 14.2626 18.3232 13.9697 18.0303C13.6768 17.7374 13.6768 17.2626 13.9697 16.9697L18.4393 12.5L13.9697 8.03033C13.6768 7.73744 13.6768 7.26256 13.9697 6.96967Z",
    fill: "#00558C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6893 11.75H9.5C8.54665 11.75 7.13332 12.0298 5.93677 12.8914C4.70198 13.7804 3.75 15.2556 3.75 17.5C3.75 17.9142 4.08579 18.25 4.5 18.25C4.91421 18.25 5.25 17.9142 5.25 17.5C5.25 15.7444 5.96468 14.7196 6.81323 14.1087C7.70002 13.4702 8.78668 13.25 9.5 13.25L17.6893 13.25L18.4393 12.5L17.6893 11.75Z",
    fill: "#00558C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1931 12.2129C20.2298 12.3013 20.25 12.3983 20.25 12.5C20.25 12.4023 20.231 12.3046 20.1931 12.2129Z",
    fill: "#00558C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonArrowPrimary);
export default __webpack_public_path__ + "static/media/button-arrow-primary.3401cdbf89527b6668978bf32395f1a9.svg";
export { ForwardRef as ReactComponent };